import axios from "axios";

import { currentSession } from "utils/auth";

axios.create({});

const BASE_DOMAIN = process.env.VUE_APP_API_URL || "http://localhost:5000";
const BASE_URL = `${BASE_DOMAIN}/v1`;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

const RESULT_CD = {
  SUCCESS: "0",
  FAIL: "9",
};

/* カスタム例外 */
class RepositoryError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = RepositoryError.getErrorCd();
  }

  static getErrorCd() {
    return "99999";
  }
}

function createErrorObject(errors) {
  const res = [];
  errors.forEach((error) => {
    res.push({
      errorCd: error.error_cd,
      errorMsg: error.error_msg,
    });
  });
  return res;
}

axiosInstance.interceptors.request.use((config) =>
  currentSession()
    .then((session) => {
      const config_with_auth = { ...config };
      config_with_auth.headers.Authorization = `${session.idToken.jwtToken}`;
      return Promise.resolve(config_with_auth);
    })
    .catch(() => Promise.resolve(config)));

axiosInstance.interceptors.response.use(
  // 何らかの処理が可能
  (response) => response,
  // 2XX範囲外のステータスコード
  (error) => {
    // error None Promise
    console.log(error);
    return Promise.reject(new RepositoryError(error.message));
  },
);

export {
  axiosInstance,
  RESULT_CD,
  RepositoryError,
  createErrorObject,
};
